import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
// Data Tables

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiIndents } from "apihandlers//indent";
const ApiReportsHandler = new ApiReports();
const ApiIndentHandler = new ApiIndents();

const ProfitLossAnalysis = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "6%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "vehicleNumber",
      name: LABELS.VEHICLE_NO,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "driverName",
      name: LABELS.DRIVER_NAME,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },

    {
      key: "fromLocation",
      name: LABELS.FROM_LOCATION,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "toLocation",
      name: LABELS.TO_LOCATION,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "tripDate",
      name: LABELS.TRIP_DATE,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "income",
      name: LABELS.INCOME,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "expense",
      name: LABELS.EXPENSE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "profit",
      name: LABELS.PROFIT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },

    {
      key: "netWeight",
      name: LABELS.NET_WT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "totalBoxes",
      name: LABELS.TOTAL_BOXES,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
    {
      key: "perWeightProfit",
      name: LABELS.PER_WEIGHT_PROFIT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },

    {
      key: "perBoxProfit",
      name: LABELS.PER_BOX_PROFIT,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      renderSum: true,
    },
  ];

  // useEffect(() => {
  //   if (loading) {
  //     loadChart();
  //   }
  // }, [loading]);

  // const getMasterData = () => {
  //   const args = {};
  //   ApiIndentHandler.getTripsList(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list: any = [{ id: -1, label: "All" }];
  //       let recs: any = response.records;
  //       for (let i = 0; i < recs.length; i++) {
  //         list.push({
  //           id: recs[i].indentId,
  //           label: recs[i].indentNo,
  //         });
  //       }
  //       setMasters(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const loadChart = () => {
    // const id = masterRef.current.selectedValue.id;
    // if (!id) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.DATA_IS_EMPTY);
    //   return;
    // }
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.FROM_DATE + ": " + fromDt + "\n" + LABELS.TO_DATE + ": " + toDt
    );
    const args = {
      fromDt,
      toDt,
      // id,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    setChartData(null);
    setRows(null);
    ApiReportsHandler.getProfitLossAnalysis(args).then((res) => {
      // console.log("getUserLogReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const masterRef: any = useRef();

  // console.log("elist:", masters);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PROFIT_LOSS_ANALYSIS}</li>
        </ul>
        <h4>{TITLES.PROFIT_LOSS_ANALYSIS}</h4>
        <p className="SubTitles">{SUB_TITLES.PROFIT_LOSS_ANALYSIS}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            {/* <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{"Select Indent :"}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
                defaultValue={{ id: -1, label: "All" }}
              />
            </div> */}
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn text={LABELS.LOAD} onClick={loadChart} />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"profitLossAnalysis"}
              title={LABELS.PROFIT_LOSS_ANALYSIS}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
              //onReload={reloadGrid}
              // onAdd={onAdd}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(ProfitLossAnalysis);
